<template>
  <div>
    <div class="row grid-justify-content-right">
      <div class="col-xs-2 col-md-6">
        <h1>{{title}} ({{selectedToDos.length}})</h1>
      </div>
      <div class="col-xs-10 col-md-6">
        <div class="input-group filters">
          <div>
            <v-button
              @click.native.prevent="activatePersonalToDos()"
              :class="{'btn--primary': selectedToDos == personalToDos, 'btn--hollow': selectedToDos !== personalToDos}"
              md>
              Mijn acties ({{personalToDos.length}})
            </v-button>
            <v-button
              @click.native.prevent="activateDepartmentToDos()"
              :class="{'btn--primary': selectedToDos == departmentToDos, 'btn--hollow': selectedToDos !== departmentToDos}"
              md>
              Acties van afdeling ({{departmentToDos.length}})
            </v-button>
            <v-button
              @click.native.prevent="activateArchiveToDos()"
              :class="{'btn--primary': selectedToDos == archiveToDos, 'btn--hollow': selectedToDos !== archiveToDos }"
              md>
              Gearchiveerde acties
            </v-button>
          </div>
        </div>
      </div>
    </div>

    <to-do-list :toDos="selectedToDos" :archive="archiveToDosActive">
    </to-do-list>
  </div>
</template>

<script>
import ToDoList from './ToDoList.vue';
import {
  currentUserIdentity$
} from '@/services';

export default {
  name: 'v-split-to-do-list',
  components: {
    ToDoList
  },
  subscriptions () {
    return {
      user: currentUserIdentity$
    };
  },
  data () {
    return {
      personalToDosActive: true,
      departmentToDosActive: false,
      archiveToDosActive: false
    }
  },
  props: {
    title: String,
    toDos: Array,
    archive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    departmentToDos() {
      return this.toDos.filter(toDo => (toDo.type === 'TransferredCustomer' && !toDo.isArchive) || (toDo.assignedToUserId !== this.user.id && !toDo.isArchive));
    },
    personalToDos() {
      return this.toDos.filter(toDo => toDo.assignedToUserId === this.user.id && !toDo.isArchive && !toDo.departmentToDo);
    },
    archiveToDos() {
      return this.toDos.filter(toDo => toDo.isArchive);
    },
    selectedToDos () {
      if (this.personalToDosActive) {
        return this.personalToDos
      }
      if (this.departmentToDosActive) {
        return this.departmentToDos
      }
      if (this.archiveToDosActive) {
        return this.archiveToDos
      }
      return [];
    }
  },
  methods: {
    activatePersonalToDos () {
      this.personalToDosActive = true;
      this.departmentToDosActive = false;
      this.archiveToDosActive = false;
    },
    activateDepartmentToDos () {
      this.personalToDosActive = false;
      this.departmentToDosActive = true;
      this.archiveToDosActive = false;
    },
    activateArchiveToDos () {
      this.personalToDosActive = false;
      this.departmentToDosActive = false;
      this.archiveToDosActive = true;
    }
  }
};
</script>

<style lang='scss' scoped>
h1 {
  color: $heading-color;
  font-size: $heading3-font-size;
  font-weight: $heading-font-weight;
  line-height: $heading3-line-height;
  margin-top: $heading-margin-top;
  margin-bottom: 20px;
}
.filters {
  justify-content: end;
  div, span {
    display: flex;
  }
}
.filter-count-button {
  align-self: center;
}
.input-group {
  display: flex;

  &__label {
    color: $gray-darkest;

    &--hidden {
      visibility: hidden;
    }
  }
}
</style>
